import styled from "@emotion/styled";

import { SectionSearchResultListItem } from "./section-search-result-list-item";

export const StyledSectionSearchResultListItem = styled(SectionSearchResultListItem)``;

export const Container = styled.div`
  padding-block: 20px;

  border-block: 1px dashed #a1a1a1;

  ${StyledSectionSearchResultListItem}:not(:last-child) {
    margin-block-end: 20px;
  }
`;

export const SectionSectionTitle = styled.p`
  margin-block-end: 4px;

  font-size: 14px;
`;
